import { render, staticRenderFns } from "./user-group-list.vue?vue&type=template&id=1cb7e3da&scoped=true"
import script from "./user-group-list.vue?vue&type=script&lang=js"
export * from "./user-group-list.vue?vue&type=script&lang=js"
import style0 from "./user-group-list.vue?vue&type=style&index=0&id=1cb7e3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7e3da",
  null
  
)

export default component.exports